/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateInvoicePaymentLinkDto
 */
export interface CreateUpdateInvoicePaymentLinkDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentLinkDto
     */
    type: CreateUpdateInvoicePaymentLinkDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentLinkDto
     */
    amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentLinkDto
     */
    salesInvoiceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentLinkDto
     */
    invoicePaymentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentLinkDto
     */
    correctionInvoiceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentLinkDto
     */
    comment?: string | null;
}


/**
 * @export
 */
export const CreateUpdateInvoicePaymentLinkDtoTypeEnum = {
    Invoice: 'Invoice',
    Withdrawal: 'Withdrawal',
    Return: 'Return',
    Correction: 'Correction'
} as const;
export type CreateUpdateInvoicePaymentLinkDtoTypeEnum = typeof CreateUpdateInvoicePaymentLinkDtoTypeEnum[keyof typeof CreateUpdateInvoicePaymentLinkDtoTypeEnum];


/**
 * Check if a given object implements the CreateUpdateInvoicePaymentLinkDto interface.
 */
export function instanceOfCreateUpdateInvoicePaymentLinkDto(value: object): value is CreateUpdateInvoicePaymentLinkDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function CreateUpdateInvoicePaymentLinkDtoFromJSON(json: any): CreateUpdateInvoicePaymentLinkDto {
    return CreateUpdateInvoicePaymentLinkDtoFromJSONTyped(json, false);
}

export function CreateUpdateInvoicePaymentLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateInvoicePaymentLinkDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'salesInvoiceId': json['salesInvoiceId'] == null ? undefined : json['salesInvoiceId'],
        'invoicePaymentId': json['invoicePaymentId'] == null ? undefined : json['invoicePaymentId'],
        'correctionInvoiceId': json['correctionInvoiceId'] == null ? undefined : json['correctionInvoiceId'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function CreateUpdateInvoicePaymentLinkDtoToJSON(value?: CreateUpdateInvoicePaymentLinkDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'amount': value['amount'],
        'salesInvoiceId': value['salesInvoiceId'],
        'invoicePaymentId': value['invoicePaymentId'],
        'correctionInvoiceId': value['correctionInvoiceId'],
        'comment': value['comment'],
    };
}

